module.exports = __webpack_public_path__ + "img/2024081410051157969t.2cc8a925.jpg";